export default "__VITE_ASSET__BxOtkyjv__";